import CommonError from '../Common/CommonError'

const Error500Container = () => {
  return (
    <CommonError error="500" color="primary" src="sad4" />
  )
}

export default Error500Container